const initVenueSelector = () => {
    const venueListSection = document.querySelector("[data-venue-list-section]");
    if (venueListSection) {
        const venueList = venueListSection.querySelectorAll("[data-venue]");
        venueList.forEach((venue) => {
            const radio = venue.querySelector("[data-radio-button]");
            const doctorId = new URL(window.location.href).searchParams.get("doctorId");
            const performanceId = new URL(window.location.href).searchParams.get("performanceId");
            const venueId = new URL(window.location.href).searchParams.get("venueId");
            const containerToAppend = document.querySelector("[data-doctors-after-venue]");
            //const contactForm: HTMLElement = document.querySelector("[data-contact-form]")
            const contactForm = document.querySelector("[data-contact-form-step]");
            if (venueId == radio.value) {
                radio.checked = true;
            }
            venue.addEventListener("click", () => {
                radio.checked = true;
                if (performanceId && doctorId) {
                    updateUrlParams(contactForm, `/GetContactForm?bookingFormId=${contactForm.getAttribute("data-contact-form-step")}&performanceId=${performanceId}&doctorId=${doctorId}&venueId=${radio.value}&stepId=3`, `venueId`, radio.value, handleFormValidation);
                    //updateUrlParams(contactForm, `/GetContactForm?bookingFormId=${contactForm.getAttribute("data-contact-form")}&performanceId=${performanceId}&doctorId=${doctorId}&venueId=${radio.value}&stepId=3`, `venueId`, radio.value, handleFormValidation);
                    contactForm.setAttribute("data-show", "show");
                }
                else if (doctorId) {
                    updateUrlParams(null, null, "venueId", radio.value, null);
                }
                else {
                    updateUrlParams(containerToAppend, `/GetDoctors?performanceId=${performanceId}&venueId=${radio.value}&stepId=3`, "venueId", radio.value, initDoctorSelector, initToggler);
                    containerToAppend.setAttribute("data-show", "show");
                    initDoctorSelectorDuplex();
                }
            });
        });
    }
};
